import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import type { RouteLocation, RouteLocationNormalized } from 'vue-router'
import { useStore } from 'vuex'
import { PAGE_ANALYTICS_INFO } from '../page-types'
import { useRequestHeader } from '#imports'

/* ------- MICROFRONT - MEMBERSHIP ------- */

export const membershipRoutes = [
  {
    path: '/customer/:customerNumber/menu',
    name: 'customer-menu',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => ({
      microFrontName: 'membership',
      viewName: 'menu',
      customerNumber: route.params.customerNumber,
    }),
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_DETAILS,
      changeSelectedCustomer: true,
      isCustomerProfileRoute: true,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: true,
    },
  },
  {
    path: '/customer/:customerNumber',
    name: 'customer-detail',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => {
      return {
        microFrontName: 'membership',
        viewName: 'customer-detail',
        customerNumber: route.params.customerNumber,
      }
    },
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_DETAILS,
      changeSelectedCustomer: true,
      isCustomerProfileRoute: true,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: true,
    },
  },
  {
    path: '/customer/:customerNumber/list',
    name: 'customer-shopping-lists',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => ({
      microFrontName: 'membership',
      viewName: `customer-shopping-lists`,
      customerNumber: route.params.customerNumber,
    }),
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_SHOPPING_LISTS,
      changeSelectedCustomer: true,
      isCustomerProfileRoute: true,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: true,
    },
  },
  {
    path: '/customer/:customerNumber/orders',
    name: 'customer-orders',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => {
      return {
        microFrontName: 'membership',
        viewName: 'customer-orders',
        customerNumber: route.params.customerNumber,
        salesId: useStore().getters.user.technical_sale_information.uuid,
      }
    },
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_ORDERS,
      changeSelectedCustomer: true,
      isCustomerProfileRoute: true,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: true,
    },
  },
  {
    path: '/customers/:customerNumber/analytics',
    name: 'customer-analytics',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => {
      return {
        microFrontName: 'membership',
        viewName: 'customer-analytics',
        customerNumber: route.params.customerNumber,
      }
    },
    beforeEnter(to: RouteLocationNormalized) {
      Object.assign(to, {
        meta: {
          ...to.meta,
          showAppHeader: !isWebViewFarmi(useRequestHeader('user-agent')),
          showSelectedCustomer: !isWebViewFarmi(useRequestHeader('user-agent')),
        },
      })
    },
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_MEMBERSHIP_ANALYTICS,
      changeSelectedCustomer: true,
      isCustomerProfileRoute: true,
      private: true,
      showAppHeader: !isWebViewFarmi(),
      showSelectedCustomer: !isWebViewFarmi(),
    },
  },
  {
    path: '/customer/:customerNumber/associated-accounts',
    name: 'associated-accounts',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => ({
      microFrontName: 'membership',
      viewName: 'associated-accounts',
      customerNumber: route.params.customerNumber,
    }),
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_ORDERS,
      changeSelectedCustomer: true,
      isCustomerProfileRoute: true,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: true,
    },
  },
  {
    path: '/customer/:customerNumber/contract',
    name: 'customer-sales-agreement',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => ({
      microFrontName: 'membership',
      viewName: 'customer-sales-agreement',
      customerNumber: route.params.customerNumber,
    }),
    meta: {
      private: true,
      analyticsPageType: PAGE_ANALYTICS_INFO.ADHERENTS_ACCOUNT,
    },
  },
  {
    path: '/customers',
    name: 'adherents-list',
    component: () => import('@b2ag/micro-front-membership/adherents-list'),
    props: () => ({
      microFrontName: 'membership',
    }),
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENTS_LIST,
      changeSelectedCustomer: true,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: true,
    },
  },
]
